import React from 'react';
import { Box, Text, Icon } from '@chakra-ui/react';
import { Collapse } from '@chakra-ui/transition';
import { IoChevronDown } from 'react-icons/io5';

import { useDetectClickOutside } from 'src/hooks';

const WarningContext = React.createContext();

const useCollapsibleWarningContext = () => React.useContext(WarningContext);

export const Warning = ({
  colorScheme = 'green',
  isOpen,
  onChange,
  closeOnClickOutside = true,
  ...rest
}) => {
  const onTriggered = () => {
    onChange?.(false);
  };

  const onToggle = () => {
    onChange?.(prev => !prev);
  };

  const ref = useDetectClickOutside({
    onTriggered,
    enabled: closeOnClickOutside,
  });

  return (
    <WarningContext.Provider value={{ colorScheme, isOpen }}>
      <Box
        bg={`${colorScheme}.50`}
        cursor="pointer"
        onClick={onToggle}
        {...{ ref }}
        {...rest}
      />
    </WarningContext.Provider>
  );
};

export const WarningTitleIcon = props => {
  const { colorScheme } = useCollapsibleWarningContext();
  return <Icon color={`${colorScheme}.600`} mr={2} {...props} />;
};

export const WarningTitle = props => {
  const { colorScheme } = useCollapsibleWarningContext();
  return <Text fontSize="sm" color={`${colorScheme}.600`} {...props} />;
};

export const WarningIcon = props => {
  const { isOpen } = useCollapsibleWarningContext();
  return (
    <Icon
      position="absolute"
      right="5px"
      as={IoChevronDown}
      color="black"
      mr={2}
      transform={isOpen ? 'rotate(-180deg)' : undefined}
      transition="transform 0.2s"
      transformOrigin="center"
      {...props}
    />
  );
};

export const WarningPanel = props => {
  const { isOpen } = useCollapsibleWarningContext();
  return <Collapse in={isOpen} {...props} />;
};
